import {Course, Lesson, Task, Test, TestSubmition} from "../../common/course";

export type InitialState = {
    course: Record<Course['id'], Course>;
    lesson: Record<Lesson['id'], Lesson>;
    task: Record<Task['id'], Task>;
    test: Record<Test['id'], Test>;
    testSubmition: Record<TestSubmition['id'], TestSubmition>;
}

export const enum ACTION_TYPES {
    GET = 'getCourses',
    LOAD_COURSES_SUCCESS = 'loadCoursesSuccess',
    GET_LESSONS = 'getLessons',
    LOAD_LESSONS_SUCCESS = 'loadLessonsSuccess',
    LOAD_TASKS_SUCCESS = 'loadTasks',
    GET_TASKS = 'getTasks',
    GET_TASK = 'getTask',
    LOAD_TASK_SUCCESS = 'loadTaskSuccess',
    MARK_TASK_AS_VISITED = 'markTaskAsVisited',
    GET_TASKS_BY_COURSE_ID = 'getTasksByCourseId',
    GET_TEST_BY_ID = 'getTestById',
    LOAD_TEST_SUCCESS = 'loadTestSuccess',
    SEND_TEST_RESULTS = 'sendTestsResults',
    GET_TEST_LAST_SUBMITION = 'getTestLastSubmition',
    LOAD_TEST_LAST_SUBMITION_SUCCESS = 'loadTestLastSubmition',
    CHANGE_TEST_STATUS = 'changeTestStatus',
};

export type CoursesPayload =
    Course |
    Course[] |
    Lesson |
    Lesson[] |
    {lessonId: Lesson['id'], taskId: Task['id']};
export type Actions = {
    type: ACTION_TYPES,
    payload?: CoursesPayload,
};